// @flow
import React, { useCallback } from 'react';
import classNames from 'classnames';
import { useField } from 'formik';
import { useDropzone } from 'react-dropzone';
import closeIcon from 'assets/images/closewhite.png';
// eslint-disable-next-line
import styles from "./styles.scss";

type Props = {
  label: string,
  name: string,
  className?: string,
  multiple?: boolean,
  value: Array<any>,
  id?: string,
  accept?: Array<string>,
};

export const FormFileUpload = (props: Props) => {
  const {
    id = '',
    label,
    className = '',
    multiple = false,
    value = [],
    accept = ['*'],
  } = props;

  const [field, meta, helpers] = useField(props);
  const setFiles = (files: Array<any>) => {
    helpers.setTouched(true);
    if (files.length === 0) {
      helpers.setValue(null);
      return;
    }
    helpers.setValue(multiple ? files : files[0]);
  };

  const onDrop = useCallback(acceptedFiles => {
    setFiles(acceptedFiles);
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept,
    multiple,
    onDrop,
  });

  const removeFile = file => {
    const updatedFiles = value.filter(v => v.name !== file.name);
    setFiles(updatedFiles);
  };

  const hasError = !!meta.error;
  const error = meta.error;
  const containerClass = classNames('form-file-upload', className, {
    'field-error': hasError,
  });

  return (
    <div className={containerClass}>
      <label htmlFor={id || field.name}>{error || label}</label>
      {(multiple || value.length === 0) && (
        <div {...getRootProps()} className={'file-upload'}>
          <input {...getInputProps()} />
          {isDragActive ? (
            <span>Drop the file here ...</span>
          ) : (
            <span>Drag & drop file, or click to select file</span>
          )}
        </div>
      )}
      {value.length > 0 && (
        <div className={'uploaded-files'}>
          {value.map((file, idx) => {
            return (
              <div className={'uploaded-file'} key={idx}>
                {file.name}
                <a onClick={() => removeFile(file)}>
                  <img src={closeIcon} alt={'close'} />
                </a>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};
